import React from "react"
// import { message } from "antd"  //error
import { Redirect } from "react-router-dom"
import store from "../store"

export default function checkRole(WrapperComponent) {
  return (props) => {
    if (store.getState().loginState) {
      return <WrapperComponent {...props} />
    } else {
      alert("您还未登录，请先进行登录！")
      return <Redirect to={{ pathname: "/" }} />
    }
  }
}
